/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ../react-toastr/node_modules/lodash/_freeGlobal.js
// module id = 50
// module chunks = 0 1 2